import { DateTime } from 'luxon';
export const isSubscriptionValid = (timeZone, subscription) => {
    // If no subscription exists, it's not valid
    if (!subscription) {
        return false;
    }
    const now = DateTime.now().setZone(timeZone);
    const periodEnd = DateTime.fromISO(subscription.currentPeriodEnd).endOf('day');
    // Check if period has ended
    if (now > periodEnd) {
        return false;
    }
    // If status is ACTIVE, it's valid
    if (subscription.status === 'ACTIVE') {
        return true;
    }
    // If status is TRIALING, it's valid within the trial period
    if (subscription.status === 'TRIALING') {
        return true;
    }
    // All other statuses are invalid
    return false;
};
